// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__qwjTj","img":"Cards_img__V6-fw","badge":"Cards_badge__fzbLD"};